import React from 'react';
import { useTheme } from '@material-ui/core';

const ZizziHeart = () => {
  const { primary, error } = useTheme().palette;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 366.81 411.01"
      height={133}
      width={153}
      fill="none"
      aria-label="Zizzi heart"
    >
      <defs>
        <clipPath id="zizzi-heart_svg__a">
          <path fill="none" d="M0 0h366.82v411.01H0z" />
        </clipPath>
      </defs>
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path fill={primary.main} d="m13.31 123.81 177.01 282.41 161.65-282.41H13.31z" />
          <g
            style={{
              clipPath: 'url(#zizzi-heart_svg__a)',
            }}
          >
            <path
              d="M247.47 280.05c-1.62.55-4 0-5.94-.23a62.18 62.18 0 0 0-12.41-.58c-8.88.66-17.93 0-27.7 1.36a81.85 81.85 0 0 0-9.51 1.36c-11.75 3.16-24.65 4.58-36.95 7.05-2 .43-4.11.81-6.14 1.19-8.27 1.48-16.1 1.33-23.87-2.67-2.06-1.74-4.44-3.33-5.83-5.71-3.05-1.51-5.1-5.86-3.92-9.11 1.57-4.17 6.53-10.09 9.92-14.79 3.22-4.38 15.11-19.75 25.32-31.55 2.26-2.64 7.92-8.35 13-16.41a134.79 134.79 0 0 1 12.88-17.17 317.16 317.16 0 0 0 20.88-26.91c-3.19-1.86-9.2-.56-12.56-1.19-9.25-1.8-17.31.23-26.39-.41a280.45 280.45 0 0 1-30.54-1.36c-1.91-4.82 1.13-9 2.41-13.08 2.7-8.7 17.6-14.36 26.59-15.2s18.5-.95 27.29 1.13c4.73 1.11 10.06 1.86 14.62 2.82 1.94.4 3.91.81 5.91 1.07s4 .78 6 .9c8.26.49 16.76.32 25.49-1.94 5.22-1.54 9.71 5 13.57 8.09 0 3.42-2.7 5.33-4.61 7.8a102.32 102.32 0 0 0-9 13.57c-1.39 2.49-4.41 6.21-6.84 9.48-5.14 7-9.92 13.17-14.16 21.64-3.51 7.13-9.74 15.16-14.52 21.86-5.66 7.92-9.81 16.85-15.52 25.32-.84 1.28-2.06 2.9-.64 4a7.2 7.2 0 0 0 3.31.61 97.35 97.35 0 0 1 11 .78c3.83.67 6.78.79 10 1.54 15.08 3.57 29.9 8.67 43 16.91 1.22 2.43-1.89 9-4.21 9.8M343.61 17.6c-30.05-28.8-81.46-19.89-110.93 9.57s-42 47.47-47.09 89.58c-12.44-39.85-23.43-59-56.52-83.06S41.46 14.53 15.79 46.92C-1.61 68.9-3.38 100.77 4.43 128s23.86 51.1 39.64 74.36l139.6 205.46a7 7 0 0 0 11.78-.06q74.07-112.32 138.41-231.13c13.58-25.08 27-51 31.53-79.37S364 37.12 343.61 17.6"
              fill={error.main}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ZizziHeart;
